const phoneNumberIsValid = phoneNumber => {
  if (!phoneNumber) return false;
  const phoneRegExp = new RegExp(/^(\+)?([0-9]){4,16}$/);
  return phoneRegExp.test(phoneNumber);
}

export default phoneNumberIsValid;
